/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-keypad/bin/core/loaders/assetloader/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-keypad/bin/core/loaders/assetloader/assettypes/BitmapFontAsset"
import {SpineAsset} from "@nolimitcity/slot-keypad/bin/core/loaders/assetloader/assettypes/SpineAsset"
import {TextureAsset} from "@nolimitcity/slot-keypad/bin/core/loaders/assetloader/assettypes/TextureAsset"

export class DumpsterFireGameAssets {

    static BITMAP_FONT_OPENSANS_800 = "NumbersOpenSans800";
    static BITMAP_FONT_WIN_COUNT_UP = "NumbersWinCountUp";
    static BITMAP_OUTRO_FONT_WIN_COUNT_UP = "NumberOutroCountUp";

    public static MAIN_GAME_BACKGROUND: string = "mainBackground";
    public static FS_BACKGROUND: string = "freespinBackground";
    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [],

        main: [
            {
                name: "fonts",
                assets: [
                    new BitmapFontAsset(DumpsterFireGameAssets.BITMAP_FONT_OPENSANS_800, "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset(DumpsterFireGameAssets.BITMAP_FONT_WIN_COUNT_UP, "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset(DumpsterFireGameAssets.BITMAP_OUTRO_FONT_WIN_COUNT_UP, "fonts/bitmapfonts/NumberOutroCountUp.fnt")
                ],
                autoLoad: [AssetQualityLevel.HIGH]
            },
            {
                name: "backgrounds",
                assets: [
                    new TextureAsset("backgroundsJpeg0", "sheets/backgroundsJpeg/backgroundsJpeg0.json"),
                    new TextureAsset("backgroundsJpeg1", "sheets/backgroundsJpeg/backgroundsJpeg1.json")
                ]
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset("L1", "spine/L1.json"),
                    new SpineAsset("L2", "spine/L2.json"),
                    new SpineAsset("L3", "spine/L3.json"),
                    new SpineAsset("L4", "spine/L4.json"),
                    new SpineAsset("L5", "spine/L5.json"),
                    new SpineAsset("M1", "spine/M1.json"),
                    new SpineAsset("M2", "spine/M2.json"),
                    new SpineAsset("M3", "spine/M3.json"),
                    new SpineAsset("M4", "spine/M4.json"),
                    new SpineAsset("W", "spine/W.json"),
                    new SpineAsset("S", "spine/S.json"),
                    new SpineAsset("XB", "spine/XB.json"),
                    new SpineAsset("XI", "spine/XI.json"),
                    new SpineAsset("XW", "spine/XW.json"),
                    new SpineAsset("upgradedScatter", "spine/upgradedScatter.json"),
                    new SpineAsset("upgradedXbomb", "spine/upgradedXbomb.json"),
                    new SpineAsset("fsScatter", "spine/fsScatter.json"),
                    new SpineAsset("clickButton", "spine/buttonCrack.json"),
                    new SpineAsset("winCap", "spine/winCap.json"),
                    new SpineAsset("fsIntro", "spine/fsIntro.json"),
                    new SpineAsset("XIBird", "spine/XI_bird.json"),
                    new SpineAsset("spinWheel", "spine/spinWheel.json"),
                    new SpineAsset("scatterAnticipation", "spine/scatterAnticipation.json"),
                    new SpineAsset("bigWin_level1", "spine/bigWin_level1.json"),
                    new SpineAsset("bigWin_level2", "spine/bigWin_level2.json"),
                    new SpineAsset("bigWin_level3", "spine/bigWin_level3.json"),
                    new SpineAsset("bigWin_level4", "spine/bigWin_level4.json"),
                    new SpineAsset("bigWin_level4_US", "spine/bigWin_level4_US.json"),
                    new SpineAsset("bigWin_level5", "spine/bigWin_level5.json"),
                    new SpineAsset("featherTransition", "spine/featherTransition.json"),
                    new SpineAsset("fsOutro_duck", "spine/fsOutro_duck.json"),
                    new SpineAsset("spinWheel_dog", "spine/spinWheel_dog.json"),
                    new SpineAsset("multiplier_highlight", "spine/multiplier_highlight.json"),
                    new SpineAsset("bg", "spine/bg.json"),
                    new SpineAsset("bg_fs", "spine/bg_fs.json")
                ]
            },
            {
                name: "main",
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("main4", "sheets/main/main4.json"),
                    new TextureAsset("main5", "sheets/main/main5.json"),
                    new TextureAsset("main6", "sheets/main/main6.json"),
                    new TextureAsset("main7", "sheets/main/main7.json"),
                    new TextureAsset("main8", "sheets/main/main8.json"),
                    new TextureAsset("main9", "sheets/main/main9.json"),
                    new TextureAsset("main10", "sheets/main/main10.json"),
                    new TextureAsset("main11", "sheets/main/main11.json"),
                    new TextureAsset("main12", "sheets/main/main12.json"),
                ],
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                animations: {
                    "upgradedScatter": "upgradedSymbols/upgradedScatter",
                    "upgradedXbomb": "upgradedSymbols/upgradedXbomb",
                    "upgradedXways": "upgradedSymbols/XI",

                    "plank1": "multipliers/plank1",
                    "plank2": "multipliers/plank2",
                    "plank3": "multipliers/plank3",
                    "plank4": "multipliers/plank4",

                    "multi2": "multipliers/milti2x",
                    "multi4": "multipliers/milti4x",
                    "multi8": "multipliers/milti8x",
                    "multi16": "multipliers/milti16x",
                    "multi32": "multipliers/milti2x32x",
                    "multi64": "multipliers/milti64x",
                    "multi128": "multipliers/milti128x",
                    "multi256": "multipliers/milti256x",
                    "multi512": "multipliers/milti512x",
                    "multi1024": "multipliers/milti1024x",
                    "multi2048": "multipliers/milti2048x",
                    "multi4096": "multipliers/milti4096x",
                    "multi8192": "multipliers/milti8192x",

                    "XI_2": "XI_multiplier/2x",
                    "XI_4": "XI_multiplier/4x",
                    "XI_8": "XI_multiplier/8x",

                    "outroSprite": "fsOutroPopup/fsOutroPopup",
                    "wheel": "spinWheel/wheel",
                    "wheelBase": "spinWheel/wheelBase",
                    "arrow": "spinWheel/arrow",

                    "upgradeBase": "spinWheel/popup/upgradeBase",
                    "bomb": "spinWheel/popup/bomb",
                    "shot": "spinWheel/popup/shot",
                    "xways": "spinWheel/popup/xways",

                    "xbombGlow": "spinWheel/xbomb",
                    "xshotGlow": "spinWheel/extra2shots",
                    "xwaysGlow": "spinWheel/infectious",
                    "upgrade_base": "bg/upgrade_base",

                    "greenBanner": "extraSpinMode/greenBanner",
                    "reel_highlight": "anticipation/reel_highlight"

                }
            },
            {
                name: "mainJpeg",
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json")
                ]
            },
            {
                name: "symbolsHighQuality",
                assets: [
                    new TextureAsset("symbolsHighQuality0", "sheets/symbolsHighQuality/symbolsHighQuality0.json")
                ],
                autoLoad: [AssetQualityLevel.HIGH],
                animations: {}
            }
        ]
    };

    public static getSymbolStateTexturePath(symbolName: string, stateName: string | null = null): string {
        if (stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "" + stateName;
    }
}
